<template>
  <main-layout>
    <b-loading :is-full-page="true" :active.sync="loading" />
    <div v-if="!loading">
      <h1 class="title">Modifica {{ courseType.code }}</h1>
      <course-type-form :item="courseType" />
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"

import CourseTypeForm from "@/components/CourseTypeForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    CourseTypeForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    courseType: get("courseTypes/courseType")
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true
    await this.fetchCourseType(to.params.id)
    this.loading = false
    next()
  },
  beforeDestroy() {
    store.set("courseTypes/courseType", {})
  },
  async mounted() {
    this.loading = true
    await this.fetchCourseType(this.$route.params.id)
    this.loading = false
  },
  methods: {
    fetchCourseType: call("courseTypes/find")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
